import { useLocale } from '@plandi/common'
import { components } from '@plandi/common/src/generated'
import { AxiosError } from 'axios'
import { useRouter } from 'next/router'
import { useQuery, UseQueryOptions } from 'react-query'

import { removeEmptyFilterOptions } from 'src/features/filters/common'
import { portfolioApi } from './portfolio.api'
import {
  PORTFOLIO_PROJECT_KEY,
  PORTFOLIO_PROJECT_LIST_KEY
} from './portfolio.constants'
import { PorfolioProjectsQueryParams } from './portfolio.types'

export const useQueryProfilePortfolioProjectList = <
  T = components['schemas']['PortfolioProjectResource'][] | undefined
>(
  reqProfileId?: number,
  options?: UseQueryOptions<
    components['schemas']['PortfolioProjectResource'][] | undefined,
    AxiosError,
    T
  >
) => {
  const router = useRouter()
  const locale = useLocale()
  const profileId = reqProfileId
    ? reqProfileId
    : router.query.profileId
    ? Number(router.query.profileId)
    : undefined

  const queryParams = removeEmptyFilterOptions({
    sort: router.query.sort
  }) as PorfolioProjectsQueryParams

  const data = useQuery(
    [PORTFOLIO_PROJECT_LIST_KEY, profileId, queryParams, locale],
    () => {
      if (profileId) {
        return portfolioApi.getProfilePortfolioProjectList(
          locale,
          profileId,
          queryParams
        )
      }

      throw new Error('Отсутствует идентификатор профиля')
    },
    options
  )

  return data
}

export const useQueryPortfolioProjectBySlug = <
  T = components['schemas']['ProfileProjectResource'] | undefined
>(
  slugName?: string,
  options?: UseQueryOptions<
    components['schemas']['ProfileProjectResource'] | undefined,
    AxiosError,
    T
  >
) => {
  const router = useRouter()
  const locale = useLocale()
  const slug = slugName
    ? slugName
    : router.query.slug
    ? (router.query.slug as string)
    : undefined

  const data = useQuery(
    [PORTFOLIO_PROJECT_KEY, slug, locale],
    () => {
      if (slug) {
        return portfolioApi.getPortfolioProjectBySlug(slug, locale)
      }

      throw new Error('Отсутствует параметр slug')
    },
    options
  )

  return data
}
